var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "./api";
import { getHeader } from "./header";
// Buscar planos do Stripe
export var getStripePlans = function () { return __awaiter(void 0, void 0, void 0, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.get("/subscriptions/stripe-plans", header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
// Buscar assinaturas do usuário logado
export var getMySubscriptions = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.get("/subscriptions/user-subscriptions", header)];
            case 2:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
// Cancelar assinatura
export var cancelSubscription = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.post("/subscriptions/".concat(id, "/cancel"), {}, header)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
// Cria um customer no Stripe (agora aceita invoiceData)
export var createStripeCustomer = function (name, paymentMethodId, invoiceData) { return __awaiter(void 0, void 0, void 0, function () {
    var header, body, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                body = {
                    cardholder_name: name,
                    payment_method_id: paymentMethodId,
                };
                if (invoiceData)
                    body.invoice_data = invoiceData; // enviar para backend
                return [4 /*yield*/, api.post("/subscriptions/create-customer", body, header)];
            case 2:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
// Cria uma subscription no Stripe (agora aceita invoiceData)
export var createStripeSubscription = function (customer_id, price_id, plan_name, coupon, referral_code, invoice_data) { return __awaiter(void 0, void 0, void 0, function () {
    var header, payload, data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                payload = {
                    customer_id: customer_id,
                    price_id: price_id,
                    plan_name: plan_name,
                };
                // ✅ Adicionar cupom APENAS se não for undefined/null/vazio
                if (coupon && coupon.trim() !== '') {
                    payload.coupon = coupon.trim();
                    // console.log('🎟️ Cupom adicionado ao payload:', payload.coupon);
                }
                else {
                    // console.log('⚠️ Cupom NÃO adicionado (vazio ou undefined)');
                }
                // ✅ Adicionar referral APENAS se não for undefined/null/vazio
                if (referral_code && referral_code.trim() !== '') {
                    payload.referral_code = referral_code.trim();
                    // console.log('👥 Referral adicionado ao payload:', payload.referral_code);
                }
                else {
                    // console.log('⚠️ Referral NÃO adicionado (vazio ou undefined)');
                }
                // ✅ Adicionar invoice_data se presente
                if (invoice_data) {
                    payload.invoice_data = invoice_data;
                    // console.log('📄 Invoice data adicionado ao payload');
                }
                return [4 /*yield*/, api.post("/subscriptions/create-subscription", payload, header)];
            case 2:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 3:
                error_1 = _a.sent();
                console.error("❌ Erro ao criar subscription:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
// Reativar assinatura
export var reactivateSubscription = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.post("/subscriptions/".concat(id, "/reactivate"), {}, header)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
// Trocar de plano (upgrade/downgrade)
export var changeSubscriptionPlan = function (id, newPriceId, newPlanName) { return __awaiter(void 0, void 0, Promise, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.post("/subscriptions/".concat(id, "/change-plan"), __assign({ new_price_id: newPriceId }, (newPlanName && { new_plan_name: newPlanName })), header)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
